import React from 'react';
import { RepeatIcon } from 'lucide-react';
import { Section } from '../ui/Section';
import { ButtonLink } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
export function PermutasSection() {
  return <Section id="permutas" className="bg-surface" data-id="element-327" data-mp="1rnbz3l9r6ol9">
      <Reveal data-id="element-328" data-mp="1ro4yg16dubtd">
        <div className="flex flex-col gap-6 rounded-3xl border border-neon/35 bg-surface2/40 p-7 backdrop-blur-md md:flex-row md:items-center md:justify-between md:p-12" style={{
        boxShadow: '0 0 55px -28px rgba(31,123,255,0.85)'
      }} data-id="element-329" data-mp="1mvtxqw3tilzr">
          <div className="max-w-2xl" data-id="element-330" data-mp="1wl55aeb23ilj">
            <span className="inline-grid h-11 w-11 place-items-center rounded-xl bg-neon/12 text-neon" data-id="element-331" data-mp="2akwb3rrf5sog">
              <RepeatIcon className="h-5 w-5" aria-hidden="true" data-id="element-332" data-mp="26j1cww4sbvew" />
            </span>
            <h2 className="mt-5 text-2xl font-extrabold tracking-tight text-white md:text-[34px]" data-id="element-333" data-mp="g758vdbf6b31">
              Aceptamos permutas
            </h2>
            <p className="mt-3 text-base leading-relaxed text-mist" data-id="element-334" data-mp="c6uzdqof52jf">
              Si tenés un vehículo usado y querés entregarlo como parte de pago, en VCARS
              evaluamos tu unidad y buscamos la mejor alternativa para que puedas avanzar
              hacia tu próximo auto.
            </p>
          </div>
          <ButtonLink to="/permutas" size="lg" className="shrink-0" data-id="element-335" data-mp="393yxxfl8g2b1">
            Consultar por permuta
          </ButtonLink>
        </div>
      </Reveal>
    </Section>;
}